<template>
  <v-card-text
    class="inserted-values px-9 pt-3"
  >
    <v-row>
      <v-col cols="auto" md="3" class="request-label">
        Nahraný soubor
      </v-col>
      <v-col cols="auto" md="9" class="request-value">
        <a @click.prevent="fileDownload($event)">
          {{ lvConnectionAgreementUpdate.file.name }}
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" md="3" class="request-label">
        Pořadí
      </v-col>
      <v-col cols="auto" md="9" class="request-value">
        {{ lvConnectionAgreementUpdate.entryNumber }}
      </v-col>
    </v-row>
    <template
      v-if="
        lvConnectionAgreementUpdate.dataEntered === true
      "
    >
      <template v-if="lvConnectionAgreementUpdate.readings">
        <v-row>
          <v-col cols="auto" md="3" class="request-label">
            Odečet - vysoký tarif
          </v-col>
          <v-col cols="auto" md="9" class="request-value">
            {{ lvConnectionAgreementUpdate.readings.highTariff || missingValueString }} kW
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto" md="3" class="request-label">
            Odečet - nízký tarif
          </v-col>
          <v-col cols="auto" md="9" class="request-value">
            {{ lvConnectionAgreementUpdate.readings.lowTariff || missingValueString }} kW
          </v-col>
        </v-row>
      </template>
      <v-row
        v-for="
          (attachment, index)
          in lvConnectionAgreementUpdate.attachments
        "
        :key="attachment.index">
        <v-col cols="auto" md="3" class="request-label">
          Příloha {{index + 1}}
        </v-col>
        <v-col cols="auto" md="9" class="request-value">
          <a @click.prevent="fileDownloadAttachment($event, index)">
            {{ lvConnectionAgreementUpdate.attachments[index].name }}
          </a>
        </v-col>
      </v-row>
    </template>
  </v-card-text>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'AgreementNNInsertedValues',
  mixins: [downloadFile, formatPhoneNumber],
  props: {
    lvConnectionAgreementUpdate: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    fileDownloadAttachment(event, type) {
      this.downloadFile(event, `requests/files/${this.lvConnectionAgreementUpdate.attachments[type].uuid}`);
    },
    fileDownload(event) {
      this.downloadFile(event, `requests/files/${this.lvConnectionAgreementUpdate.file.uuid}`);
    },
  },
};
</script>
